// @flow

import React, { type Node } from 'react';
import { useIncomingPayment, getReceipts } from '@tectonics/prs/incoming-payment';
import { getLocalTax } from '@tectonics/prs/receipts';
import { getReceiptAmountExt, getReceiptAmountLocalTotal } from '@tectonics/prs/receipts/receipt';
import { amountToCurrencyString, getLocalTaxCodeFromString } from '@tectonics/prs/money';
import { getCurrencyCode } from '@tectonics/prs/money/amount/get-currency-code';

import { getMoneyFormat } from '../../../commons/money-format';
import './modal.css';

type PagofacilTaxesModalProps = {|
  status: string,
  closeModal: () => void,
|};

export default function PagofacilTaxesModal({ status = '', closeModal}: PagofacilTaxesModalProps): Node {
  const incomingPayment = useIncomingPayment();

  const receipt = getReceipts(incomingPayment).main;

  const decimalFormat = getMoneyFormat(incomingPayment.country);
  const formatAmount = amountToCurrencyString(decimalFormat);

  const displayAmountExt = (receipt) => {
    const amountExt = getReceiptAmountExt(receipt);

    return `${formatAmount(amountExt)} ${getCurrencyCode(amountExt)}`;
  };

  const buildReceiptTaxes = (receipt) => {
    var taxes = [];

    const argentineTaxes = {
      ar_iva: 'IVA',
      ar_ip: 'Pais',
      ar_ig_ibp: 'Ganancias',
    };

    Object.keys(argentineTaxes).forEach(taxCode => {
      var localTax = getLocalTax(receipt, getLocalTaxCodeFromString(taxCode));

      if (!localTax) return;

      var taxPercentage = localTax.rate
        ? parseFloat(localTax.rate) * 100
        : 0;

      if (taxPercentage > 0) {
        taxes.push({
          name: argentineTaxes[taxCode],
          percentage: taxPercentage,
          amount: `${formatAmount(localTax.amount)} ${getCurrencyCode(localTax.amount)}`,
        });
      }
    });

    return (
      <>
        {taxes.map((tax) => (
          <tr key={tax.name}>
            <td className="u-text-left">{tax.name} ({tax.percentage}%)</td>
            <td className="u-text-right">{tax.amount}</td>
          </tr>
        ))}
      </>
    );
  };

  const displayAmountTotal = (receipt) => {
    const amountLocalTotal = getReceiptAmountLocalTotal(receipt);

    return `${formatAmount(amountLocalTotal)} ${getCurrencyCode(amountLocalTotal)}`;
  };

  return (
    <div id="taxes-modal" className={`c-modal ${status}`}>
      <div className="o-overlay"></div>
      <div className="o-modal-body">
        <div>
          <table>
            <thead>
              <tr>
                <td colSpan="2" className="u-text-left">
                  <strong>Tarifas</strong>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="u-text-left">Valor original</td>
                <td className="u-text-right">{displayAmountExt(receipt)}</td>
              </tr>
              {buildReceiptTaxes(receipt)}
            </tbody>
            <tfoot>
              <tr>
                <td className="u-text-left">
                  <strong>Valor total</strong>
                </td>
                <td className="u-text-right">
                  <strong>{displayAmountTotal(receipt)}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
          <div className="u-text-right">
            <button type="button" id="close-taxes-modal-btn" className="o-close-modal-btn" onClick={() => closeModal()}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
}
